import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { detailsAction } from "../redux/slices/detailsSlice";
import Alert from '../components/Alert';
import { addPostAction, postsAction } from '../redux/slices/postsSlice';
import { addRatingAction } from '../redux/slices/ratingsSlice';
import NavBar from '../components/Navigation/NavBar';
import CustomInput from '../components/CustomInput';
import CommentModel from '../components/CommentModel';
import Rating from '../components/Rating';
import StarRating from '../components/StarRating';
import { followAction, unfollowAction } from '../redux/slices/usrSlice';
import CustomIcon from '../components/CustomIcon';
import CustomImage from '../components/CustomImage';
import { PAGE_CONSTANT, handleErrorResponse, handleHrefRedirect, runAnalytic, runAnalytic_v2, validatePincode_v2 } from '../services/functions';
import logo from '../logo192.png';
import DetailsUserInfo from '../components/DetailsUserInfo';
import { assertAuth } from '../utility/authGuard';
import { isValidField } from '../utility/fieldValidator';
import { showAlert } from '../redux/slices/alertSlice';
import { fieldValidators } from '../utility/validators';

const Details = () => {
  const { id } = useParams();

  const authData = useSelector(state => state?.auth?.data);
  const detailsData = useSelector(state => state?.details?.data);
  const details = useSelector(state => state?.details);
  const postsData = useSelector(state => state?.posts?.data);


  const dispatch = useDispatch();
  const [counter, setCounter] = useState(0);
  const [isShowInit, setIsShowInit] = useState(false);
  const [state, setState] = useState({ id: authData?.id, otherUserId: id, comment: "", rating: '', postOffice: '' });

  const commentsSlice = detailsData?.commentByOthers?.slice(0, 2);
  const commentByOthersData = detailsData?.commentByOthers;
  const commentsCount = detailsData?.commentByOthers?.length;

  const ratingByOthersData = detailsData?.ratingByOthers || [];
  const ratingByOthersGroupByData = groupBy(ratingByOthersData, rating => rating.rating);
  const alreadyRated = ratingByOthersData.filter((el) => {
    return el.user?.[0] === authData?.id
  }).length;

  const alreadyFollowing = detailsData?.followers?.find(u => u?.toString() === authData?.id?.toString());
  const hideFollow = detailsData?.followers?.find(u => u?.toString() == authData?.id?.toString());
  const hideMobile = detailsData?.category?.find(u => u?.name?.toLowerCase() === "user");
  
  useEffect(() => {
    let ignore = false;
    runAnalytic_v2({categoryToAdd:detailsData.category?.[0]?.name, authData,dispatch,page:PAGE_CONSTANT.DETAILS_PAGE,producer:state?.otherUserId,searchCategoryId:detailsData.category?.[0]?.id})
    
    const fetchData = async () => {
      if (!ignore) {
        dispatch(detailsAction({ ...state }));
        //await validatePincode_v2(detailsData?.pincode, setState);
      }
    };

    fetchData();

    return () => { ignore = true; }
  }, [id]);

  const handleSubmit = (type, rating) => e => {
    e.preventDefault();
    
    const redirectPath = detailsData?.id ? `/details/${detailsData.id}` : null;
    if (!assertAuth(authData, dispatch,redirectPath)) { return; }

    if (type === "post") {
      dispatch(addPostAction({ ...state, comment:state?.comment?.trim() }));
      setState({ ...state, comment: "" })
    }

    if (type === "rating") {
      dispatch(addRatingAction({ ...state, rating: rating }));
      setState({ ...state, rating: "" })
    }

    if (type === "follow") {
      dispatch(followAction({ ...state }));
    }

    if (type === "unfollow") {
      dispatch(unfollowAction({ ...state }));
    }



    // setTimeout(() => {
    //   console.log('timeout')
    //   setIsShowInit(false);
    // }, 5000);

  }

  const handleClose = (e) => {
    e.preventDefault();
    setIsShowInit(false);
  };

  const handleChange = input => e => {
    e.preventDefault();
    //setState({ ...state, [input]: e.target.value });
    const value = e.target.value;
    const validator = fieldValidators[input];
    const errorMessage = validator ? validator(value) : "";
    setState({ ...state, [input]: value, [`${input}Error`]: errorMessage });
  }

  function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  const handlePhoneCall = () => {
    // Replace `1234567890` with the actual phone number
    runAnalytic_v2({categoryToAdd:detailsData?.category?.[0]?.name, authData,dispatch,page:PAGE_CONSTANT.DETAILS_PAGE_CALL_CLICK,producer:detailsData?.id,searchCategoryId:detailsData?.category?.[0]?.id})
    if (window?.cordova && window?.cordova?.InAppBrowser) {
      cordova.InAppBrowser.open(`tel:${detailsData.mobile}`, "_system");
    } else {
      window.location.href = "tel:" + detailsData.mobile;
    }
  };

  const handleWhatsApp = () => {
    // Replace `1234567890` with the actual phone number
    window.location.href = "https://api.whatsapp.com/send?phone="+detailsData.mobile;
  };

  const openCommentModal = async () => {
    const modalElement = document.getElementById('commentModal');
    if(modalElement){
      $(modalElement).modal('show'); // For Bootstrap 4
      modalElement.focus();
    }
  }


  return (
    <>
      <NavBar />

      <div className="main-container">
        <div className="d-flex flex-column align-items-center px-3">
          {!details.loading && !details.appErr && !details.serverErr ? (<>
            <div className="mt-3 mb-3 animated-border">
              {/* <CustomImage className="circle" src="https://picsum.photos/300/300"/> */}
              <CustomImage state={{image:detailsData?.profilePhoto,name:detailsData.name}} className={"detail_page__image"} size={"18rem"}/>
            </div>

            {(authData?.id !== detailsData?.id && alreadyFollowing  && !hideMobile) ? 
            (<p>
              <button className="btn btn-outline-warning mb-3" onClick={handleSubmit("unfollow")}>Unfollow</button>
            </p>) : ''}

            {(authData?.id !== detailsData?.id  && !alreadyFollowing && !hideMobile) ? 
            (<p>
              <button className="btn btn-outline-info mb-3" onClick={handleSubmit("follow")}>Follow</button></p>
            ) : ''}

            <DetailsUserInfo hideMobile={hideMobile} detailsData={detailsData} authData={authData}/>

            {!hideMobile ? (<Rating ratingByOthersGroupByData={ratingByOthersGroupByData} ratingByOthersData={ratingByOthersData} />) : ''}

            {/* View Reviews Button */}
            <div className="uic-section details-user-info-responsive m-2 p-2 mb-2">
              <button type="button" className="btn btn-outline-primary mb-3" disabled={commentByOthersData?.length < 1} onClick={openCommentModal}>
                  <i className="fa fa-comments uic-icon" /> View {commentByOthersData?.length > 1 ? `all ${commentByOthersData?.length} reviews` : "review"}
              </button>
            </div>

            <CommentModel detailsData={detailsData}/>
            {!hideMobile  && alreadyRated < 1 && authData?.id !== detailsData?.id ? (<StarRating handleSubmit={handleSubmit} />) : ''}

            {/* <CustomInput title="" id="ratingId" type="number" placeholder="Enter rating" handleChange={handleChange} name="rating" value={state.rating}/> */}
            {/* <button className="btn btn-outline-primary mb-3" onClick={handleSubmit("rating")}>Post ratings</button> */}

            {authData?.id !== detailsData?.id && !hideMobile ? (
            <div className="uic-section details-user-info-responsive m-2 p-2">
              <CustomInput title="Post comments" id="postId" type="text" placeholder="Share your experience..." handleChange={handleChange} name="comment" value={state?.comment} state={state} maxLength={100}/>
              <button className="btn btn-outline-primary mb-3" onClick={handleSubmit("post")} disabled={!state?.comment || state?.commentError}><i className="fa fa-paper-plane uic-icon" /> Post comments</button>
            </div>) : ''}
          </>) : ''}

          {!details.loading && (details.appErr || details.serverErr) ? (<div>Seems some issue, please try again later!!</div>) : ""}
        </div>
      </div>

    </>
  );
}

export default Details;
